/**
 * SAQIA Viewer (LiDAR) integration — docs/viewer-integration/CONTRACT_v1.md.
 *
 * `links` says which of the user's farms the viewer has (empty when the
 * integration is off or the viewer is down: the menu entry just hides).
 * `authorize` is the login hand-off: SAQIA issues a one-time code and tells
 * us where to send the browser.
 */
import apiClient from './apiClient';

export interface ViewerLinks {
  enabled: boolean;
  /** farm UUID -> viewer deep link */
  farms: Record<string, string>;
}

export interface ViewerAuthorizeParams {
  response_type: string;
  client_id: string;
  redirect_uri: string;
  state: string;
  code_challenge: string;
  code_challenge_method: string;
  farm_id?: string;
}

export const AUTHORIZE_PARAMS = [
  'response_type', 'client_id', 'redirect_uri', 'state',
  'code_challenge', 'code_challenge_method', 'farm_id',
] as const;

export const viewerApi = {
  links: (): Promise<ViewerLinks> => apiClient.get<ViewerLinks>('/viewer/links'),
  authorize: (params: ViewerAuthorizeParams): Promise<{ redirect_to: string }> =>
    apiClient.post<{ redirect_to: string }>('/viewer/authorize', params),
};
